module.exports = __webpack_public_path__ + "img/Group 1278.48acc1aa.svg";